var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRightMedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 177,
    height: 8,
    viewBox: "0 0 177 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M176.512 4.35357C176.707 4.15831 176.707 3.84173 176.512 3.64646L173.33 0.464483C173.135 0.26922 172.818 0.26922 172.623 0.464483C172.427 0.659745 172.427 0.976327 172.623 1.17159L175.451 4.00002L172.623 6.82844C172.427 7.02371 172.427 7.34029 172.623 7.53555C172.818 7.73081 173.135 7.73081 173.33 7.53555L176.512 4.35357ZM0.158203 4.5L176.158 4.50002L176.158 3.50002L0.158203 3.5L0.158203 4.5Z",
    fill: "#787878"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightMedium);
export default __webpack_public_path__ + "static/media/ArrowRightMedium.58f2653a9435d3da909de31753c397cb.svg";
export { ForwardRef as ReactComponent };